export default __webpack_public_path__ + "static/media/facebook.a83a8f33.svg";